<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Datos generales</h6>
      <p class="text-body-2">Ingrese la fecha y el proveedor de la orden de pago</p>
      <v-row class="mt-0">
        <v-col md="4">
          <v-combobox
            v-model="item.supplier"
            data-vv-as="proveedor"
            autocomplete="off"
            item-text="name"
            item-value="id"
            :items="suppliers"
            v-validate="'required|combobox_required'"
            label="Proveedor*"
            class="pt-0 mt-0"
            clearable            
            :disabled="isViewModal || (item.spents && item.spents.length > 0)"
            filled
          ></v-combobox>
          <span class="red--text">{{ errors.first("proveedor") }}</span>
        </v-col>
        <v-col md="4" class="mt-2">
          <DatePickerEsp
            :initToday="true"
            label="Fecha*"
            :date="item.cbte_fch"
            :isRequired="true"
            name="cbte_fch"
            @setDate="(date) => { item.cbte_fch = date; }"
            :isViewModal="isViewModal"
          />
        </v-col>
        <v-col md="4" class="mt-2">
          <DatePickerEsp
            :initToday="false"
            label="Fecha Estimada de Pago"
            :date="item.estimated_payment_date"
            :isRequired="false"
            name="estimated_payment_date"
            @setDate="(date) => { item.estimated_payment_date = date; }"
            :isViewModal="isViewModal"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" class="mt-0">
          <v-combobox
            v-model="item.receiver"
            data-vv-as="receptor"
            name="receiver"
            autocomplete="off"
            item-text="name"
            item-value="id"
            :items="receivers"
            label="Receptor"
            :loading="loading_receivers"
            :disabled="isViewModal || (item.spents && item.spents.length > 0)"
            clearable
          ></v-combobox>
          <span class="red--text">{{ errors.first("receptor") }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import DatePickerEsp from "@/components/DatePickerEsp.vue";

export default {
  components: { DatePickerEsp },
  props: { 
    item: Object, 
    isViewModal: Boolean, 
    open: Boolean, 
    validator: Object 
  },
  created() {
    this.$validator = this.validator;
  },
  data: () => ({ 
    suppliers: [], 
    receivers: [], 
    loading_receivers: false 
  }),
  watch: {
    open: function (val) {
      if (val) {
        this.loadReceivers();
      }
    },
  },
  mounted() {
    this.geSuppliers();
    this.loadReceivers();
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleString('es-AR');
    },
    geSuppliers() {
      generalService.setSection(Constant.SECTION_SUPPLIERS);
      generalService
        .filter()
        .then((response) => {
          this.suppliers = response.result;
          this.loading = false;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    loadReceivers() {
      this.loading_receivers = true;
      emmiterService
        .filter({ enabled: true })
        .then((response) => {
          this.receivers = response.result;
          if (response.result.length == 1 && this.item.receiver == null) {
            this.item.receiver = response.result[0];
          }
        })
        .catch((e) => {
          console.log("emmiterService.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_receivers = false;
        });
    },
  },
};
</script>
